<svg
  width="20"
  height="20"
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <circle opacity="0.2" cx="8.5" cy="8.5" r="6.5" fill="currentColor" />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M12.3345 13.749C11.2596 14.5356 9.93402 15 8.5 15C4.91015 15 2 12.0899 2 8.5C2 4.91015 4.91015 2 8.5 2C12.0899 2 15 4.91015 15 8.5C15 9.93419 14.5355 11.2599 13.7488 12.3349L17.6564 16.2425L16.2422 17.6567L12.3345 13.749ZM13 8.5C13 10.9853 10.9853 13 8.5 13C6.01472 13 4 10.9853 4 8.5C4 6.01472 6.01472 4 8.5 4C10.9853 4 13 6.01472 13 8.5Z"
    fill="currentColor"
  />
</svg>
